import { createSelector } from 'reselect';
import {
  ADD_PAYMENT,
  filterByReloadActionType,
  validPaymentInstrumentsSelector,
} from 'shared/app/bundles/wallet';

export const reloadPaymentInstrumentsSelector = createSelector(
  validPaymentInstrumentsSelector,
  (paymentInstruments) => {
    const addPaymentInstrument = {
      paymentType: ADD_PAYMENT,
      paymentInstrumentId: ADD_PAYMENT,
    };

    const filteredPaymentInstruments = filterByReloadActionType([
      ...paymentInstruments,
    ]);

    return [...filteredPaymentInstruments, addPaymentInstrument];
  }
);
